module.exports = __webpack_public_path__ + "static/gareso-296bc2e0ba31e0aab607f941d9b5b121.png";